module.exports = __webpack_public_path__ + "static/media/HS.3e2ae018.pdf";